import Promise from 'promise-polyfill';
import defaultDemoAccount from '../templates/defaultDemoAccount.json';
import defaultDemoAccountEditorX from '../templates/defaultDemoAccountEditorX.json';
import WixService from './WixService';
import {
  SET_COMMENTS,
  ADD_COMMENTS,
  SET_COMMENTS_PAGING,
  COMMENTS_LOADING,
  ALL_COMMENTS_LOADED,
} from '../../constants';
import { getComments } from '../api/instagramApi';
import { falsifyKeys } from '../more/utils';

/**
 * Get comments by mediaId
 * @param {*} mediaId - id of media
 */
export const getCommentsByMediaId = (
  dispatch,
  mediaId,
  commentsPagination,
  accessToken,
  userId,
  isTemplate,
  mediasIdArray = [],
) => {
  let demoAccountId;
  if (isTemplate && !userId && !accessToken) {
    demoAccountId = WixService.isEditorX()
      ? defaultDemoAccountEditorX.id
      : defaultDemoAccount.id;
  }

  const commentsLoadingObj = {};
  const getCommentsArray = [];
  const addCommentsObj = {};
  for (const id of mediasIdArray) {
    commentsLoadingObj[id] = true;
    const after = commentsPagination[id] || '';
    if (after) addCommentsObj[id] = after;
    getCommentsArray.push(
      getComments(id, after, accessToken, userId, isTemplate, demoAccountId),
    );
  }

  dispatch({
    type: ALL_COMMENTS_LOADED,
    payload: false,
  });

  dispatch({
    type: COMMENTS_LOADING,
    payload: {
      commentsLoadingObj: commentsLoadingObj,
      allCommentsLoaded: false,
    },
  });

  if (getCommentsArray.length) {
    Promise.allSettled(getCommentsArray).then((commentsData) => {
      if (Object.keys(addCommentsObj).length) {
      }
      const commentsObject = {};
      const totalPaging = {};
      for (const commentIdx in commentsData) {
        const postId = mediasIdArray[commentIdx];
        if (commentsData[commentIdx].value) {
          const { data, paging } = commentsData[commentIdx].value;
          const newAfter = (paging && paging.cursors?.after) || '';
          commentsObject[postId] = data || '';
          totalPaging[postId] = newAfter;
        }
      }
      dispatch({
        type: SET_COMMENTS,
        payload: commentsObject,
      });

      dispatch({
        type: SET_COMMENTS_PAGING,
        payload: totalPaging,
      });

      dispatch({
        type: COMMENTS_LOADING,
        payload: {
          commentsLoadingObj: falsifyKeys(commentsLoadingObj),
          allCommentsLoaded: true,
        },
      });

      dispatch({
        type: ALL_COMMENTS_LOADED,
        payload: true,
      });
    });
  }
};

export const addCommentsByMediaId = (
  dispatch,
  mediaId,
  after,
  accessToken,
  userId,
  isTemplate,
) => {
  getComments(mediaId, after, accessToken, userId, isTemplate).then(
    (comments) => {
      const { data, paging } = comments;
      const after = (paging && paging.cursors?.after) || '';
      dispatch({
        type: SET_COMMENTS_PAGING,
        payload: { [mediaId]: after },
      });
      dispatch({
        type: ADD_COMMENTS,
        payload: { mediaId, addedComments: data },
      });
    },
  );
};
